/* eslint-disable no-inline-comments */
// @flow
import React, { useEffect, useRef, useState } from 'react';
import { dataLayer } from '@finect/front-gtm';
import { AppLink } from '@finect/tabular-core/AppLink';
import { getLoginBaseURL } from '@finect/front-utils/getLoginBaseURL';
import { getBaseURL } from '@finect/front-utils/env';
import { getPlusItem } from '../../utils/ga4Plus';
import { OptionCard } from './components';
import { PlusUpgradeModal } from './PlusUpgradeModal';
import { Overlay, Box, Content, Options, ActionsFooter } from './partials';

type Props = {
  modal?: boolean,
  user: Object,
  backUrl: string,
  prices?: Object
};

export const PlusSubscribeModalContent = ({ modal = true, user, backUrl, prices }: Props) => {
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const viewItemSent = useRef(false);

  useEffect(() => {
    if (prices?.monthly?.price && prices?.yearly?.price && !viewItemSent.current) {
      dataLayer({
        id: 'PlusProduct',
        type: 'view_item',
        params: {
          value: Number((prices.monthly.price + prices.yearly.price).toFixed(2)),
          items: [
            getPlusItem('monthly', prices.monthly.price, prices.monthly.original),
            getPlusItem('yearly', prices.yearly.price, prices.yearly.original)
          ]
        }
      });
      viewItemSent.current = true;
    }
  }, [prices]);

  const paymentUrl = `/servicios/finect-plus/comprar`;

  const buyUrl = user.isLoggedIn ? `${paymentUrl}` : `${getLoginBaseURL()}?next=${getBaseURL() + paymentUrl}`;

  return (
    <Overlay modal={modal}>
      <Box>
        <Content plus modal={modal}>
          <Options plus>
            <OptionCard plus option="free" url={backUrl} />

            <OptionCard
              plus
              option="basic"
              url={buyUrl}
              prices={prices}
              onMonthlyClick={() => setShowUpgradeModal(true)}
            />
          </Options>

          {!user.isLoggedIn && (
            <ActionsFooter>
              ¿Ya tienes cuenta con nosotros?
              <br />
              <AppLink href={getLoginBaseURL()}>Inicia sesión</AppLink>
            </ActionsFooter>
          )}
        </Content>
      </Box>

      {showUpgradeModal && <PlusUpgradeModal buyUrl={buyUrl} prices={prices} />}
    </Overlay>
  );
};
